import { Wallet } from "lucide-react";

interface WalletDisplayProps {
  balance: number;
  className?: string;
}

const WalletDisplay = ({ balance, className = "" }: WalletDisplayProps) => {
  return (
    <div className={`inline-flex max-w-full items-center gap-1.5 rounded-full border border-primary/20 bg-primary/5 px-2.5 py-1 backdrop-blur-sm ${className}`}>
      <Wallet className="h-3 w-3 shrink-0 text-primary/80" />
      <span className="truncate font-heading text-xs font-semibold tabular-nums text-foreground/90 sm:text-sm">${balance}</span>
    </div>
  );
};

export default WalletDisplay;
